// Money is whole cents (RK-SYS-002 conventions). Rand is the only currency.
export function formatRand(cents: number | bigint | null | undefined, opts: { sign?: boolean } = {}): string {
  if (cents === null || cents === undefined) return "—";
  const c = typeof cents === "bigint" ? Number(cents) : cents;
  const neg = c < 0;
  const abs = Math.abs(Math.round(c));
  const rands = Math.floor(abs / 100);
  const rest = String(abs % 100).padStart(2, "0");
  const grouped = rands.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const s = `R${grouped}.${rest}`;
  if (neg) return `-${s}`;
  return opts.sign && c > 0 ? `+${s}` : s;
}

/** Parse "R1,656,000.00", "1656000", "1 656 000,00" into cents. Returns null when unreadable. */
export function parseRandToCents(text: string): number | null {
  const t = text.replace(/[R\s\u00a0]/gi, "").trim();
  if (!t) return null;
  let norm = t;
  if (/,\d{2}$/.test(t) && !/\.\d{2}$/.test(t)) norm = t.replace(/\./g, "").replace(",", ".");
  norm = norm.replace(/,/g, "");
  if (!/^-?\d+(\.\d{1,2})?$/.test(norm)) return null;
  const [whole, frac = ""] = norm.replace("-", "").split(".");
  const cents = Number(whole) * 100 + Number(frac.padEnd(2, "0"));
  return norm.startsWith("-") ? -cents : cents;
}
